import React from "react";

const style = {
  transform: 'translate3d(0, -64px, 0)'
};
const Anchor = ({id, style: propsStyle}) => {
  return <div id={id} style={propsStyle || style}/>
};
export default Anchor;
